import React from "react";
import { useUserContext } from "context/UserContext";
import WarehousesBK from "layouts/BK/warehouses";
import WarehousesCM from "layouts/CM/warehouses";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function Warehouses() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (isManagementRoleLevel(numericRoleLevel)) {
    return <WarehousesBK />;
  }
  if (numericRoleLevel === 4 || numericRoleLevel === 5) {
    return <WarehousesCM />;
  }
  return null;
}

export default Warehouses;
